export default __webpack_public_path__ + "static/media/yotam-zimri.1203475f.png";